export const DISRUPTION_NOTICES_TEST_ID = 'DisruptionNotices';
export const DISRUPTION_NOTICES_HEADING = 'DisruptionNoticesHeading';
export const DISRUPTION_NOTICES_CHEVRON_LINK_TEST_ID = 'DisruptionNoticesChevronLink';
export const DISRUPTION_NOTICES_CTA_LINK_TEST_ID = 'DisruptionNoticesCtaLink';
export const DISRUPTION_NOTICES_LIST_TEST_ID = 'DisruptionNoticesList';
